import { render, staticRenderFns } from "./ListRegiContentStatus.vue?vue&type=template&id=2674d84d"
import script from "./ListRegiContentStatus.vue?vue&type=script&lang=js"
export * from "./ListRegiContentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports